import { useMemo } from 'react'
import client from '~/client'
import {
  ZoneStatusFragmentDoc,
  type ZoneStatusFragment,
} from '~/gql/generated/graphql'
import { isNotNullOrUndefined } from '~/utils/types'

// Read info about zones out of the apollo cache
export const useSelectedZones = (ids: string[]) => {
  const zones = useMemo<ZoneStatusFragment[]>(
    () =>
      ids
        .map(id =>
          client.readFragment({
            id: `Zone:${id}`,
            fragment: ZoneStatusFragmentDoc,
          }),
        )
        .filter(isNotNullOrUndefined),
    [ids],
  )

  // little helpers
  const statusStats = useMemo(
    () => ({
      promotional: zones.filter(z => z.is_promotional).length,
      notPromotional: zones.filter(z => !z.is_promotional).length,
      priority: zones.filter(z => z.is_priority).length,
      notPriority: zones.filter(z => !z.is_priority).length,
    }),
    [zones],
  )

  return { zones, statusStats }
}
